import router from './router/index'
import Vue from 'vue'
const vm = new Vue()
router.beforeEach((to, from, next) => {
  window._axiosPromiseArr.forEach((ele, index) => {
    ele.cancel()
    delete window._axiosPromiseArr[index]
  })
  // var login = localStorage.getItem('token')
  console.log(localStorage.permission)
  var menu = localStorage.permission ? localStorage.permission.split(',') : []
  var path = to.path
  if (path === '/login' || path === '/401' || path === '/403' || path === '/csms/developer') {
    next()
    return
  }
  if (!menu.length) {
    vm.$message({
      message: 'This account does not have permission to enter csms!',
      type: 'info',
      duration: 3 * 1000
    })
    next({
      path: '/403'
    })
  }
  console.log(path)
  if (path) {
    // if (path === '/csms/secret') {
      console.log(menu, path.split('/csms/')[1])
      if (menu.indexOf('menu-' + path.split('/csms/')[1]) !== -1 || menu.indexOf('menu-secret/' + path.split('/csms/')[1]) !== -1) {
        next()
      } else {
        const defaultPath = menu[0].split('-')[1]
        next({
          path: '/csms/' + defaultPath
        })
      }
    // }
  }
  // if (login) {
  //   if (path) {
  //     next()
  //   }
  // } else {
  //   if (localStorage.redirectUrl) {
  //     vm.$message({
  //       message: 'Jumping to okta in 3 seconds...',
  //       type: 'info',
  //       duration: 3 * 1000
  //     })
  //     setTimeout(function () {
  //       window.location.href = localStorage.redirectUrl
  //     }, 3000)
  //   } else {
  //     next({
  //       path: '/'
  //     })
  //   }
  // }
})
